import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../core/services/auth-rol.service';

@Injectable({
  providedIn: 'root',
})
export class PackingBoxViewAuthService extends AuthRolService {
  Deparment?: string;
  protected override outsideDepartmentRoles = [
    'Admin',
    'Chief',
    'QualityControl',
    'LabelOperator',
  ];
  createLabel(_partNumber?: string): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
    ]);
  }

  allowPrintingStation(): boolean {
    return this.createLabel();
  }

  rankingSalesOrder(): boolean {
    return this.lookForRolesNeeded(['Admin', 'Chief']);
  }

  authorizeCustomLabel(): boolean {
    return this.lookForRolesNeeded(['Admin', 'Chief']);
  }

  createCustomLabel(): boolean {
    return !this.onlyViewers([
      'Polyurethane',
      'Filter',
      'Compression',
      'Compounding',
      'InjectionMolding',
      'PleatPack',
      'PleatPacks',
    ]);
  }
}
